"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openSearchBar = void 0;
function openSearchBar() {
    var _a, _b;
    (_a = document.getElementById('opensearch')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
        var _a;
        (_a = document.getElementById('searchbar')) === null || _a === void 0 ? void 0 : _a.setAttribute('style', 'display: inline-block');
    });
    (_b = document.querySelector('#searchbar span.close')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
        var _a;
        (_a = document.getElementById('searchbar')) === null || _a === void 0 ? void 0 : _a.setAttribute('style', 'display: none');
    });
}
exports.openSearchBar = openSearchBar;
